import SDatePicker from 'components/SDatePicker';
import PropTypes from 'prop-types';
import React from 'react';
import QDateRangePicker from './QDateRangePicker';

const DatePicker = (props) => {
  const { range } = props;

  // QDatePicker routes date range selection QDateRangePicker_V2 and single date selection to SDatePicker
  if (range) {
    return <QDateRangePicker {...props} />;
  }

  const adpatedProps = { ...props, onChange: props.onSelect }; // map onSelect() to onChange()
  return <SDatePicker {...adpatedProps} />;
};

DatePicker.propTypes = {
  id: PropTypes.string,
  legacy: PropTypes.bool,
  dateRange: PropTypes.string,
  startingDate: PropTypes.object,
  endingDate: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  disableFutureDates: PropTypes.bool,
  disablePastDates: PropTypes.bool, // v2
  selectedRangeId: PropTypes.string, // v2
  ranges: PropTypes.array, // v2
  maxDaysAfter: PropTypes.number, // v2
  maxDayRange: PropTypes.number, // v2
  shortcuts: PropTypes.array, // v2
  selectedId: PropTypes.string, // v2
  allowCustomRange: PropTypes.bool, // v2
  format: PropTypes.string, // v1
  anchorEl: PropTypes.object, // v1
  onClose: PropTypes.func, // v1
  range: PropTypes.bool, // v1
  popoverProps: PropTypes.object, // v1
  showPartialMonthDays: PropTypes.bool, // v1
  compact: PropTypes.bool,
  reloadTxns: PropTypes.bool,
};

export default DatePicker;
